// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._10wg4rq0 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--_18w76bwd);
  padding: var(--_18w76bwh) var(--_18w76bwg);
  border-radius: 4px;
  border: 1px solid var(--_18w76bw2v);
  background: var(--_18w76bw2u);
}
._10wg4rq1 {
  margin: var(--_18w76bwd) var(--_18w76bwb);
}
@media screen and (max-width: 768px) {
  ._10wg4rq0 {
    margin: 0 var(--_18w76bwe);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,0CAA0C;EAC1C,kBAAkB;EAClB,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["._10wg4rq0 {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--_18w76bwd);\n  padding: var(--_18w76bwh) var(--_18w76bwg);\n  border-radius: 4px;\n  border: 1px solid var(--_18w76bw2v);\n  background: var(--_18w76bw2u);\n}\n._10wg4rq1 {\n  margin: var(--_18w76bwd) var(--_18w76bwb);\n}\n@media screen and (max-width: 768px) {\n  ._10wg4rq0 {\n    margin: 0 var(--_18w76bwe);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
